import { apiGet } from '@api/api.utils'
import { IResponseDeclinationString, IResponseEducationStartEndDate } from "./api.types"


const route = '/common'

/** Получение - Даты начала обучения и конец обучения */
export const getEducationStartEndDate = (startDate?: string, countMonthOrWeek?: number, isWeek?: number): Promise<IResponseEducationStartEndDate> => 
    apiGet<IResponseEducationStartEndDate>(`${route}/getEducationStartEndDate`, {params: {startDate, countMonthOrWeek, isWeek}})

/** Получение - Склонение строки */
export const getDeclinationString = (fio?: string, post?: string): Promise<IResponseDeclinationString> => 
    apiGet<IResponseDeclinationString>(`${route}/getDeclinationString`, {params: {fio, post}})